import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import ArrowBack from "../../assets/img/arrow-back.svg";

const useStyles = makeStyles({
  backAction: {
    background: "#E2D0D9",
    width: "45px",
    height: "45px",
    borderRadius: "39px",
    position: "absolute",
    left: 0,
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
    },
  },
});

const PreviousStepBtn = ({ handleBack }) => {
  const { backAction } = useStyles();
  return (
    <Box
      className={backAction}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      onClick={() => handleBack()}
    >
      <img src={ArrowBack} alt="arrow-back" />
    </Box>
  );
};

export default PreviousStepBtn;
